/* RESPONSIBLE TEAM: team-inbox */
import Service, { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import { request } from 'embercom/lib/inbox/requests';
import { AsyncData } from 'embercom/resources/utils/async-data';
import { use } from 'ember-resources/util/function-resource';
import type { SenderEmailAddressSettingsWireFormat } from 'embercom/components/new-settings/workspace/brands/types/sender-email-address-settings';
import type { BrandWireFormat } from 'embercom/components/new-settings/workspace/brands/types/brand';

export default class Inbox2BrandService extends Service {
  @service declare session: Session;

  @use brands = AsyncData(async (): Promise<BrandWireFormat[]> => {
    let response = await request(`/ember/brands?app_id=${this.session.workspace.id}`);
    let data = await response.json();
    return data as BrandWireFormat[];
  });

  @use senderEmailAddressSettings = AsyncData(async () => {
    let response = await request(
      `/ember/sender_email_address_settings?app_id=${this.session.workspace.id}`,
    );
    let data = (await response.json()) as SenderEmailAddressSettingsWireFormat[];
    return data.map((wireFormat: SenderEmailAddressSettingsWireFormat) => ({
      id: wireFormat.id,
      email: wireFormat.email,
      brandId: wireFormat.brand_id,
      verified: wireFormat.verified,
    }));
  });

  /**
   * Loads both brands and sender email address settings data needed for showing brand info in user search dropdown
   */
  async loadBrandDataForUserSearch() {
    return Promise.all([this.brands.promise, this.senderEmailAddressSettings.promise]);
  }

  get isPaywallOverrideActive() {
    return this.session.workspace.isFeatureEnabled('multibrand-ignore-paywall');
  }

  get isAppOnRightMultibrandPlan() {
    if (this.session.workspace.isFeatureEnabled('multibrand-ignore-paywall')) {
      return true;
    } else if (this.session.workspace.isFeatureEnabled('messenger_multibrand')) {
      return true;
    }
    return false;
  }
}

declare module '@ember/service' {
  interface Registry {
    inbox2BrandService: Inbox2BrandService;
  }
}
